import { jsx as _jsx } from "react/jsx-runtime";
import { MSystemGroup } from '@svs/ui/react/bet-button';
import { useMemo } from 'react';
import { cn } from '../utils/entry.js';
import convertOutcomeCountToLabels from './convertOutcomeCountToLabels.js';
/**
 * This component is responsible for rendering the correct amount of outcomes and converting the outcome count to correct labels.
 *
 * @param root0 Component that displays the outcome.
 * @param root0.className Classname for the component
 * @param root0.selectedOutcomes Array with selected outcomes
 * @param root0.outcomeCount Number of outcomes
 * @param root0.renderItem Function to render the outcome
 * @param root0.localDistribution Optional local distribution for outcome labels
 * @param root0.eventNumber Unique identifier for the event
 * @param root0.outcomeDistribution Optional distribution for the outcomes, used to display the percentage of each outcome
 * @returns Component that displays the outcome.
 */
export default function CouponEventOutcomesPrediction({
  className,
  outcomeCount,
  selectedOutcomes,
  renderItem,
  localDistribution,
  eventNumber,
  outcomeDistribution
}) {
  const outcomeLabels = useMemo(() => convertOutcomeCountToLabels(outcomeCount, localDistribution), [outcomeCount, localDistribution]);
  // z-index fix for betbuttons since overlapping link-area causes issues with clicking when in multi coupon mode in desktop
  return _jsx(MSystemGroup, {
    className: cn('z-2 grid w-full grid-cols-3 justify-items-center gap-x-1.5 [grid-area:betButtons] [&>*:first-child]:justify-self-start [&>*:last-child]:justify-self-end', className),
    children: outcomeLabels.map(({
      outcome
    }, index) => renderItem({
      isSelected: selectedOutcomes?.length ? selectedOutcomes.includes(index) : false,
      outcome: localDistribution && localDistribution[index] !== undefined ? `${localDistribution[index]}%` : outcome,
      index,
      state: outcomeDistribution ? 'reduced' : undefined,
      reducedPercentage: eventNumber && outcomeDistribution ? outcomeDistribution[eventNumber - 1]?.[index] : undefined
    }))
  });
}